import React from "react";

const EmploymentContract = () => {
  return (
    <div className="py-10 space-y-5">
      <div className="flex justify-between">
        <span>State of Washington</span>
        <span>Rev. 133C785</span>
      </div>
      <h1 className="text-2xl sm:text-3xl w-fit mx-auto uppercase font-bold border-double border-b-4">
        EMPLOYMENT AGREEMENT
      </h1>
      <p>
        This Employment Agreement (the "Agreement') is made as of this 22 day of
        JanuMY, 2018, (the Date') by md between RIAolph M Hettinw (AEmployee•),
        located at 4488 Thomas Street, Springfield CBIter, NY 13468 Susan C
        Clarke, located at 1493 and Street, Seattle, WA 98161 CEmployer'),
        (each, a •Party' and collectively, "Parties'). The Parties agree and
        covenant to be bound by the terms set forth in this Agreernent as
        follows:
      </p>
      <p>
        1. <b>Employment.</b> Employer shall employ Employee as a Personal
        Assistant on a fun time basis under t)is Agreement. In this capacity,
        Empbyee shall have the following duties and undertake the following
        responsibilities:
      </p>
      <ul className="list-disc pl-5 space-y-3">
        <li>manage correslnldence for the CEO</li>
        <li>sit in on meetings when the CEO is unable to attend</li>
        <li>offer valuable msight to cornpany products</li>
      </ul>
      <p>
        Employee shall perform such other duties as are cusft)mariy perfcrmed by
        other persons sü•nilar positms, including other duties as may arise from
        tirne to time and as may be assigned.
      </p>
      <p>
        2. Performance of Duties. Employee shall perform assigned duties and
        responsibilities in a manner, in go«i faith, and to the best of
        Employee's skills, abdities, talents and experience.
      </p>
      <p>
        3. Term. Ernployee's employment under this Agreement shall begin on
        January 29, 2018 and be for an unspecified term on an "at basi&
      </p>
      <p>
        <b>4. Convensation.</b>
      </p>
      <ul className="pl-5 space-y-3">
        <li>
          <b>A. Base Salary.</b> As compensatim for the services provided by
          Employee under this Agreement, Employer will pay Employee SIS-OO USD
          per hour. The amount will be paid to Employee once a month on the 7th
          day of each month_ Employer shall deduct or withhold any and all
          federal income and social security taxes and state or local taxes as
          required by law.
        </li>
        <li>
          <b> B. Overtime.</b> Employee shall not receive overtime cornpensatjm
          for services as a salaried or exempt ernployee.
        </li>
        <li>
          <b>C. Additional Compensation.</b> Any additional cornpensatbn or
          bonuses paid to Employee shall be paid at the sole discretion of
          Employer.
        </li>
      </ul>
      <p></p>

      <p>
        5. Work Location. Ernployee wul prirnarily perfirrn ther enwoyrnent
        duties at 1493 Main street, seawe, WA 98161-
      </p>
      <p>
        6. <b>Employee Benefits.</b> Both parties will comply with Employer
        policy rewding employee benefits or as required by law.
        <span className="ml-2">
          <b>A. Paid Time Off.</b> Employee shall be entitled to paid tirne off
          in the amomt of as required by state and local laws.
        </span>
      </p>
    </div>
  );
};

export default EmploymentContract;
